<template>
  <div id="externalPosConnection">

    <!-- POS -->
    <Panel class="panel-connection" :title="$t('external_pos_connection.pos_title')">
      <div class="holder">

        <div class="status" :class="{connected: posConnected}">
          <div class="icon">
            <svgicon :src="posConnected ? '/icon/check.svg' : '/icon/disconnected.svg'" :height="20" :width="20"></svgicon>
          </div>
          <div class="content">
            <div class="title">{{ $t('external_pos_connection.status') }}</div>
            <span class="connection" v-if="posConnected">{{ $t('external_pos_connection.connected') }}</span>
            <span class="connection" v-if="!posConnected">{{ $t('external_pos_connection.disconnected') }}</span>
          </div>
        </div>

        <div class="content">
          <div class="description">
            <p>{{ $t('external_pos_connection.description_pos') }}</p>
            <p v-html="$t('tips.external_pos_connection.assistance')"></p>
          </div>
          <div class="group">
            <button class="btn btn-primary" @click="checkPosConnection">{{$t('external_pos_connection.check_external_pos')}}</button>
          </div>
          <div class="group" v-if="isNwApp()">
            <button class="btn btn-primary" @click="checkTunnelConnection">{{ $t('external_pos_connection.restart_tunnel') }}</button>
          </div>
        </div>

      </div>
    </Panel>

  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "externalPosConnection",

    data() {
      return {
        posConnected: false,
        tunnelConfigPath: Parameters.tunnelConfigPath,
        tunnelStatusPath: Parameters.tunnelStatusPath,
        restartReceptionGatewayPath: Parameters.restartReceptionGatewayPath,
        company: null,
        data: {
          selected: null,
          tunnel: {
            url:'tunnel.ishopfood.com',
            port: "",
            sshUsername: "",
            sshKey: "",
          },
          maitre: {
            url: null,
            host: null,
          },
          veloce: {
            host: '',
            port: '',
            local_ip: ''
          },
          isfAgentPolling : {
            maximumRetry: null,
            salesPollingInterval: null
          },
        }
      }
    },

    computed: {
      isCheckConnectionAvailable() {
        return this.data.selected === 'maitre' || this.data.selected === 'veloce' || this.data.selected === 'screen'
            || this.data.selected === 'isfAgentPolling';
      }
    },

    async mounted() {
      this.companyId = this.$route.query.company;
      this.branchId = this.$route.query.branch;
      showSpinner();

      try {
        let [externalPosData, company] = await Promise.all([
          this.getCompanyExternalPos({companyId: this.companyId, branchId: this.branchId}),
          this.$store.getters.getContextCompany
        ]);

        if (externalPosData) {
          this.posConnected = !externalPosData.emergencyCloseExternalOffline;
          this.data.selected = externalPosData.selected[0] || this.data.selected;
          this.data.tunnel = externalPosData.tunnel || this.data.tunnel;
          this.data.veloce = externalPosData.veloce || this.data.veloce;
          this.data.aki = externalPosData.aki || this.data.aki;
          this.data.maitre = externalPosData.maitre || this.data.maitre;
          this.data.screen = externalPosData.screen || this.data.screen;
          this.data.isfAgentPolling = externalPosData.isfAgentPolling || this.data.isfAgentPolling

          //Create the file use by bash file to restart tunnel
          if (this.isNwApp()) {
            if (this.data.selected === "maitre") {
              this.createTunnelConfigFileForMaitreD();
            } else if  (this.data.selected === "veloce") {
              this.createTunnelConfigFileForVeloce();
            }
          }
        } else {
          toast(this.$t("error.no_server"), "error");
        }

        this.company = company;

        hideSpinner();
      } catch (e) {
        console.log("error", e);
        toast(this.$t("error.no_server"), "error");
      }
    },

    methods: {
      ...mapActions(["getCompanyExternalPos", "retryExternalPosConnection"]),

      isNwApp() {
        return isExecutable();
      },

      async checkPosConnection() {
        if (!this.isCheckConnectionAvailable) {
          toast(this.$t("error.action_not_supported"), "error");
          return;
        }

        showSpinner();
        let response = await this.retryExternalPosConnection({ companyId: this.companyId });
        hideSpinner();
        // Success
        if (response && response.active === true) {
          this.posConnected = true;
          toast(this.$t("external_pos_connection.connection_success"), "success");
          return;
        }
        // Error
        this.posConnected = false;
        if (response.error) {
          toast(this.$t(`error.${response.error}`), 'error');
        } else {
          toast(this.$t("external_pos_connection.connection_failed"), "error");
        }
      },

      isTunnelConfiguration() {
        if (this.data.selected === "maitre") {
          return this.data.maitre.url.includes("tunnel");
        } else if (this.data.selected === "veloce") {
            return this.data.veloce.host.includes("tunnel");
        } else if (this.data.selected === "screen") {
          return true;
        } else {
            return false;
        }
      },

      async checkTunnelConnection() {
        if(!this.isTunnelConfiguration()) {
          toast(this.$t("error.action_not_supported"), "error");
          return;
        }

        if (this.data.selected === "screen") {
          nw.Shell.openItem(this.restartReceptionGatewayPath);
          console.log('executed', this.restartReceptionGatewayPath);
        } else {
          nw.Shell.openItem(this.tunnelStatusPath);
          console.log('executed', this.tunnelStatusPath);
        }

      },

      createTunnelConfigFileForMaitreD() {
        let config = {
          "user": this.data.tunnel.sshUsername,
          "key": this.data.tunnel.sshKey,
          "server_host": this.data.tunnel.url,
          "server_ip": "52.35.160.43",
          "server_port": this.data.tunnel.port,
          "local_host": "localhost",
          "local_port": 80,
          "external_pos": 'maitre'
        };
        let fs = nw.require("fs");
        fs.writeFile(this.tunnelConfigPath, JSON.stringify(config), (err) => {
          if (err) throw err;
          console.log('The file has been saved!');
        });
        console.log('file content', this.tunnelConfigPath, config);
      },

      createTunnelConfigFileForVeloce() {
        let config = {
          "user": this.data.tunnel.sshUsername,
          "key": this.data.tunnel.sshKey,
          "server_host": this.data.tunnel.url,
          "server_ip": "52.35.160.43",
          "server_port": this.data.tunnel.port,
          "local_host": this.data.veloce.localHost,
          "local_port": this.data.veloce.localPort,
          "external_pos": 'veloce'
        };
        let fs = nw.require("fs");
        fs.writeFile(this.tunnelConfigPath, JSON.stringify(config), (err) => {
          if (err) throw err;
          console.log('The file has been saved!');
        });
        console.log('file content', this.tunnelConfigPath, config);
      },
    }
  }
</script>

<style lang="scss" scoped>
$active-color: #36d53d;
$inactive-color: #f63730;

#externalPosConnection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.panel-connection {
  max-width: 680px;
}

.holder {
  display: flex;
  align-items: center;
}

.description {
  margin-bottom: 30px;
}

.status {
  flex-shrink: 0;
  padding: 30px 20px;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-right: 30px;
  display: flex;
  align-items: center;
  min-width: 220px;

  &.connected {
    .icon {
      background-color: $active-color;
    }

    .connection {
      color: $active-color;
    }
  }

  &:not(.connected) {
    .icon {
      background-color: $inactive-color;
    }

    .connection {
      color: $inactive-color;
    }
  }

  .icon {
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;

    .svgicon {
      fill: white !important;
      margin-right: 0;
    }
  }

  .title {
    font-size: 14px;
    color: #808080;
  }

  .connection {
    font-size: 20px;
    font-weight: 800;
  }
}

@media screen and (max-width: 720px) {
  #externalPosConnection {
    display: block;
  }
  .holder {
    flex-direction: column;

    .status {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
}
</style>
